import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { userRequest, isNotEmpty, signupCall, loginCall } from "../../util/user";
import socks from '../../images/main1.jpg';
import logo from '../../images/new_logo.svg';
import poop_5 from '../../images/main1.jpg';
import { oauthInit, oauthFunction } from '../../util/oauth';
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons';

export default class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      user: this.props.user,
      email: "",
      full_name: "",
      password: "",
      password_confirmation: "",
      UserForm: this.props.user || {}
    }

    this.login = this.login.bind(this)
    this.hideErrorCtn = this.hideErrorCtn.bind(this)
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.oauthStart = this.oauthStart.bind(this);
  }

  oauthStart(argument) {
    const state = this;

    oauthFunction(state, argument);
  }

  login() {
    loginCall(this);
  }

  signup() {
    signupCall(this);
  }

  getUserRequest() {
    // if the token already exists, a session with that user already exists
    // so can set user up
    userRequest(this).then((user) => {
      this.props.setUser(user)
      this.props.setUserContext();
    });
  }

  handleRadioChange(e) {
    // really bad practice.
    let user = this.state.user || this.props.user;
    user = Object.assign({}, user, {WantsEmail: !user.WantsEmail})

    this.setState({
      user: user
    });
  }

  hideErrorCtn() {
    this.setState({
      errorMessage: undefined
    });
  }

  handlePassChange(e) {
    this.setState({ password: e.target.value });
  }

  handlePassConfChange(e) {
    this.setState({ password_confirmation: e.target.value });
  }

  handleFullNameChange(e) {
    this.setState({ full_name: e.target.value });
  }

  handleEmailChange(e) {
    this.setState({ email: e.target.value });
  }

  render() {
    const error = this.state.errorMessage;
    let errorDetail = <div></div>

    if (error !== undefined) {
      errorDetail = <div onClick={this.hideErrorCtn} className="notification-ctn error">
        {error}
      </div>
    }

    return (
    <div className="two-pane">
      <div className="right-side yellow-bg account-inputs">
        <div className="cta-account">
          <div className="top">
            <img className="logo" src={logo} alt="Logo"/>
            <h3>The best Hamilton Homes for you</h3>
          </div>
          <div className="bottom">
            We have the best homes for you! Make an account to see full details
          </div>
        </div>

        <input
        value={this.state.email}
        onChange={ this.handleEmailChange.bind(this) }
        placeholder="Email" />
        <input
        value={this.state.password}
        type="password"
        onChange={ this.handlePassChange.bind(this) }
        placeholder="Password" />

        <br/>
        <button className="submit-post" onClick={this.login}>Login</button>

        <div id="signup-instead" className="submit-post" onClick={this.props.changeUserContext}>Don't have an account? <span className="yellow-font">Signup instead</span></div>
        <div className="submit-post" onClick={this.props.changeUserContextToForgot}>Forgot your password? <span className="yellow-font">Click Here</span></div>
      </div>

      <div className="left-side">
        <img className="socks" src={socks} alt="No Pants No Problem"/>
      </div>

      {errorDetail}
    </div>
  )}
}
